var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { observer } from 'mobx-react';

import { editingMode } from 'sdc-cms-writing';
import { TextValueEditor } from '../text/text';

var FieldEdit = observer(function (_ref) {
  var field = _ref.field,
      locale = _ref.locale,
      props = _objectWithoutProperties(_ref, ['field', 'locale']);

  if (editingMode.isViewMode.get() || !field.editable) return null;
  if ((field.dataType || 'text') !== 'text') return null;
  if ((field.display || 'single') !== 'single') return null;

  locale = locale || {};

  return React.createElement(TextValueEditor, _extends({ field: field, locale: locale }, props));
});
export { FieldEdit };